(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2414],{

/***/ 97240:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expired-purchase",
      function () {
        return __webpack_require__(49197);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34745);




/**
 * 全部设备过期超 30 天且无有效未绑单时的落地页（与 SpyX 一致）。
 * 页面本身只是个空壳：弹窗由 VerticalLayout 内的 ExpiredPurchaseGuide（SEVERE）统一渲染。
 *
 * ⚠️ 这个文件不能删：useExpiredPurchaseGuide / navigation / pages/index 都会把用户跳到这里，
 * 缺了它会被 pages/[slug].js（博客页）接住。
 */ const ExpiredPurchasePage = ()=>{
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_3__/* .setCurrentTab */ .Lw)(""));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_3__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "min-h-[calc(var(--vh2)*100-200px)] w-full",
        "aria-hidden": true
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ExpiredPurchasePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(97240); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);